import { Connected } from './connected'

Connected.define('fp-connected')

declare global {
  interface HTMLElementTagNameMap {
    'fp-connected': Connected;
  }
}

export default Connected
